
import * as React from "react";
import { Grid } from "@material-ui/core";
import { Filter1, Filter2 } from "@material-ui/icons";
// import { compose, withProps } from "recompose";


// import { IStore } from "src/store";
// import { connect } from "react-redux";

export interface RaceDataComponentProps {
    race: any;
    images?: string[];
}


export interface ScheduleState {
    
}


class ScheduleRacesList extends React.Component<RaceDataComponentProps, ScheduleState> {

    constructor(props: RaceDataComponentProps) {
        super(props);
       
    }

    componentDidMount() {
        // Esto se ejecuta solo una vez al montar el componente (como componentDidMount)
        console.log("Componente montado");
        // Aquí puedes hacer fetch, cargar datos, etc.
    }
 

    render() {

        // Puedes usar race e images aquí según lo necesites

        return (
            <Grid container direction="row" style={{ marginTop: '10px', marginBottom: '10px' }}>
                <Grid item md={12}>
                    <h5>Datos de la carrera</h5>
                </Grid>

                <Grid container direction="row">
                    <Grid item md={4} style={{ marginRight: '15px' }}>
                        <h6 style={{ display: 'flex', alignItems: 'flex-start' }}><Filter1 /><label>Visitador</label></h6>
                    </Grid>
                    <Grid item md={4} style={{ marginRight: '15px' }}>
                        <h6 style={{ display: 'flex', alignItems: 'flex-start', marginTop: '5px' }}><Filter2 /><label>Origen</label></h6>
                    </Grid>
                </Grid>
                <Grid item md={12}>
                    <hr />
                    <Grid container direction="row" style={{ display: 'flex', alignItems: 'center' }}>
                        <h6>Clientes a Repartir</h6>
                    </Grid>
                    
                    <div style={{ width: '100%' }}>
                        <div>
                            <div style={{ display: 'flex', justifyContent: 'space-around' }}>
                                <div style={{ width: '11%' }}><label style={{ fontSize: '13px' }}>Cliente</label></div>
                                <div style={{ width: '11%' }}><label style={{ fontSize: '13px' }}>Fecha</label></div>
                                <div style={{ width: '11%' }}><label style={{ fontSize: '13px' }}>Tipo de reparto</label></div>
                                <div style={{ width: '11%' }}><label style={{ fontSize: '13px' }}>Tipo de documento</label></div>
                                <div style={{ width: '11%' }}><label style={{ fontSize: '13px' }}>N° documento opcional</label></div>
                                <div style={{ width: '11%' }}><label style={{ fontSize: '13px' }}>Fijar precio</label></div>
                                <div style={{ width: '17%' }}><label style={{ fontSize: '13px' }}>Obs</label></div>
                                <div style={{ width: '17%' }}><label style={{ fontSize: '13px' }}>Hoja de ruta</label></div>
                                <div style={{ width: '6%' }}><label style={{ fontSize: '13px' }}>Orden</label></div>
                                <div style={{ width: '5%' }}><label style={{ fontSize: '13px' }}>Acciones</label></div>
                            </div>
                        </div>
                        <div>
                            {/* Aquí puedes renderizar los datos de los clientes */}
                        </div>
                    </div>
                    <br />
                </Grid>
            </Grid>
        );
    }
}

// const mapStateToProps = (state: IStore, ownProps: any) => ({
//     ...ownProps,
//     race: state.race,
//     config: state.config.data,
// });

export default ScheduleRacesList;


// WEBPACK FOOTER //
// ./src/components/ScheduleRacesList.tsx